import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { authApi } from '../api/auth.js';
import { oublierIdentite } from './identite.js';

export interface Authentification {
  readonly deconnecter: () => Promise<void>;
}

/**
 * Déconnexion : révoque la session côté API puis — même si l'API n'a pas
 * répondu — oublie l'identité, annule les requêtes en vol et vide le cache
 * ENTIER avant de revenir à `/connexion`. Le compte suivant n'hérite de rien
 * (audit MVP du 23/09, § 2). La file hors ligne du stand, elle, est gardée
 * sous la clé de CE compte (`routes/stand/fileHorsLigne.ts`).
 */
export function useAuthentification(): Authentification {
  const client = useQueryClient();
  const navigate = useNavigate();

  async function deconnecter(): Promise<void> {
    try {
      await authApi.deconnexion();
    } catch {
      /* API injoignable : la purge locale a lieu quand même */
    }
    await oublierIdentite(client);
    await navigate('/connexion', { replace: true });
  }

  return { deconnecter };
}
